import { getApiBaseUrl } from "@/config/runtime";
import type { DataResponse, PaginatedResponse } from "@/types";
import { api } from "../api";

export interface FeedbackItem {
  uuid: string;
  category: "bug" | "feature";
  title: string;
  description: string;
  status: "open" | "in_progress" | "resolved" | "closed";
  pageUrl: string | null;
  userAgent: string | null;
  screenshots: Array<{
    blobName: string;
    originalFilename: string;
    contentType: string;
    size: number;
    url: string;
  }>;
  adminNotes: string | null;
  createdAt: string;
  updatedAt: string;
  resolvedAt: string | null;
  userName: string | null;
  userEmail: string | null;
}

export const feedbackService = {
  list: (params?: { page?: number; pageSize?: number; category?: string; status?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.pageSize) searchParams.set("page_size", String(params.pageSize));
    if (params?.category) searchParams.set("category", params.category);
    if (params?.status) searchParams.set("status", params.status);
    return api.get<PaginatedResponse<FeedbackItem>>(`/feedback?${searchParams}`);
  },

  updateStatus: (feedbackUuid: string, data: { status: string; admin_notes?: string | null }) =>
    api.patch<DataResponse<FeedbackItem>>(`/feedback/${feedbackUuid}`, data),

  /** Build the URL for a screenshot image (streamed by the backend). */
  screenshotUrl: (feedbackUuid: string, blobName: string) =>
    `${getApiBaseUrl()}/feedback/${feedbackUuid}/screenshots/${blobName}`,
};
